import { useQuery } from '@tanstack/react-query';

import { publicApiClient } from '@/lib/api/publicClient';

import { sessionDetailDtoSchema } from '../schemas/sessionSchemas';

export const publicSessionKeys = {
  detail: (token: string) => ['publicSession', token] as const,
};

// Loads a session for the anonymous applicant via its public link token. No auth,
// no tenant — the backend resolves everything from the token.
export function usePublicSession(token: string | undefined) {
  return useQuery({
    queryKey: publicSessionKeys.detail(token ?? ''),
    queryFn: async ({ signal }) => {
      const raw = await publicApiClient.get(`api/v1/public/sessions/${token}`, { signal }).json();
      return sessionDetailDtoSchema.parse(raw);
    },
    enabled: !!token,
    // The applicant journey is short-lived; don't refetch under them mid-run.
    staleTime: 60_000,
  });
}
